export default "__VITE_ASSET__CxpsSeD0__"